import { Component, OnInit, Input } from '@angular/core';
import { AuthService } from '../auth.service';
import { NgForm } from '@angular/forms';
import { AppState } from '../../app.service';

@Component({
  templateUrl: './resetPassword.component.html',
  styleUrls: [
    './resetPassword.component.scss'
  ]
})
export class AuthResetPasswordComponent implements OnInit {
  @Input()
  public stateParams;

  public email: string;
  public code: string;

  public isSuccess: boolean = false;

  public password = {
    new: null,
    old: null
  };

  public errorMessage: string;

  public errors = {
    mismatch: false,
    failed: false
  };

  constructor(private authService: AuthService, private appState: AppState) {

  }

  public ngOnInit() {
    if (this.stateParams && this.stateParams.c && this.stateParams.e) {
      this.email = this.stateParams.e;
      this.code = this.stateParams.c;
    }
  }

  public resetMessages() {
    this.errors = {
      failed: false,
      mismatch: false
    };

    this.errorMessage = null;
  }

  public toogleMenu (evt: any) {
    evt.stopPropagation();
    this.appState.set('isMenuActive', true);
  }

  public handleSubmit(form: NgForm) {
    this.resetMessages();

    if (form.valid) {
      this.authService.resetPassword(decodeURIComponent(this.email), this.code, this.password.new)
        .subscribe(
          (result) => {
            this.isSuccess = true;
          },
          (err) => {
            switch (err.code) {
              case 'CodeMismatchException':
                this.errors.mismatch = true;
                break;
              default:
                this.errorMessage = err.message;
            }
          }
        );
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/auth/resetPassword/resetPassword.component.ts